"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var smarttagsToUrl_1 = __importDefault(require("tagmanager-connector/lib/smarttagsToUrl"));

var urlToSmarttags_1 = __importDefault(require("tagmanager-connector/lib/urlToSmarttags"));

function filterToUrl(filter) {
  return filter.reduce(function (acc, f) {
    if (f.type === 'doctype' || f.type === 'limit' || f.type === 'parentSection' || f.type === 'section' || f.type === 'siblingSections') {
      acc.push(f.type + "=" + encodeURIComponent(String(f.value)));
    } else if (f.type === 'smarttag') {
      acc.push("" + f.type + (f.subtype === 'excludes' ? '_exclude' : '') + "=" + encodeURIComponent(smarttagsToUrl_1["default"](f.value)));
    }

    return acc;
  }, []).join('&');
}

exports.filterToUrl = filterToUrl;

function urlToFilter(url) {
  if (!url || url.length === 0) {
    return [];
  }

  return url.split('&').reduce(function (acc, part) {
    var _a = part.split('='),
        key = _a[0],
        value = _a[1];

    if (key === 'doctype' || key === 'limit' || key === 'parentSection' || key === 'section' || key === 'siblingSections') {
      acc.push({
        type: key,
        value: decodeURIComponent(value)
      });
    } else if (key === 'smarttag') {
      acc.push({
        type: 'smarttag',
        subtype: 'includes',
        value: urlToSmarttags_1["default"](decodeURIComponent(value))
      });
    } else if (key === 'smarttag_exclude') {
      acc.push({
        type: 'smarttag',
        subtype: 'excludes',
        value: urlToSmarttags_1["default"](decodeURIComponent(value))
      });
    }

    return acc;
  }, []);
}

exports.urlToFilter = urlToFilter;

function transformDeprecatedWidget(widget) {
  if (widget.type === 'fb') {
    var type = widget.type,
        config = __rest(widget, ["type"]);

    return {
      type: 'social',
      subtype: 'facebookpage',
      config: config
    };
  }

  return widget;
}

exports.transformDeprecatedWidget = transformDeprecatedWidget;

function transformDeprecatedContent(content) {
  return content.map(transformDeprecatedWidget);
}

exports.transformDeprecatedContent = transformDeprecatedContent;